t = require('views/internal/teacup-with-helpers')('header_member_menu')

module.exports = t.renderable ({ hasAccount, onAnyBoardView, profileUrl, cardsUrl, billingUrl, accountUrl, canLogOut, upsellEnabled }) ->
  entry = (href, key, className) ->
    t.li ->
      args = { class: className, href }
      t.a args, ->
        t.format key

  list = (body) ->
    t.ul '.pop-over-list', body

  list ->
    entry profileUrl, 'profile', 'js-profile'
    entry cardsUrl, 'cards', 'js-cards'
    if hasAccount && upsellEnabled
      entry billingUrl, 'billing', 'js-billing'
    entry accountUrl, 'settings', 'js-account'

  t.hr()

  list ->
    entry '/contact', 'help', 'js-help'
    if onAnyBoardView
      entry '/shortcuts/overlay', 'shortcuts', 'js-shortcuts'
    else
      entry '/shortcuts', 'shortcuts', 'js-shortcuts'
    entry '#', 'change-locale', 'js-change-locale'

  t.hr()

  list ->
    t.li ->
      t.a '.js-logout', { href: '#' }, ->
        t.format 'log-out'
        if !canLogOut
          t.br()
          t.format 'you-ll-need-to-set-a-password-first'
        return



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_member_menu.coffee